<emperor-dialog-header
  [title]="config.data?.naicsDescription"
></emperor-dialog-header>
<emperor-card-content>
  <div class="body" [innerHTML]="sanitizedExplanation()"></div>
</emperor-card-content>
